import { render, staticRenderFns } from "./BasicDashboardRevenue.vue?vue&type=template&id=624c0173&scoped=true&lang=true"
import script from "./BasicDashboardRevenue.vue?vue&type=script&lang=js"
export * from "./BasicDashboardRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c0173",
  null
  
)

export default component.exports